import React, { createContext, useContext, useState } from 'react';

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    // Return a no-op implementation when not wrapped in LoadingProvider
    return {
      isLoading: false,
      setIsLoading: () => {},
      markComponentLoaded: () => {},
      isComponentLoaded: () => false,
      allComponentsLoaded: () => true
    };
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [loadedComponents, setLoadedComponents] = useState(new Set());

  const markComponentLoaded = (componentName) => {
    setLoadedComponents(prev => {
      const newSet = new Set(prev);
      newSet.add(componentName);
      return newSet;
    });
  };

  const isComponentLoaded = (componentName) => {
    return loadedComponents.has(componentName);
  };

  const allComponentsLoaded = () => {
    const requiredComponents = [
      'HeroCarousel',
      'WhyHaazri',
      'HowItWorks',
      'FeaturesSection',
      'PricingSection',
      'Testimonials',
      'FAQ'
    ];

    return requiredComponents.every(comp => loadedComponents.has(comp));
  };

  React.useEffect(() => {
    if (allComponentsLoaded() && isLoading) {
      setIsLoading(false);
    }
  }, [loadedComponents]);

  return (
    <LoadingContext.Provider value={{
      isLoading,
      setIsLoading,
      markComponentLoaded,
      isComponentLoaded,
      allComponentsLoaded
    }}>
      {children}
    </LoadingContext.Provider>
  );
};
